<template>
  <div class="form-background">
    <a href="/">
      <img
        src="@/assets/logo_black.png"
        class="logo"
      >
    </a>

    <Loader v-if="pending" />
    <div
      v-else-if="response"
      class="response-info text-center"
    >
      <div>
        <div class="text-center sent">
          <i class="fas fa-check-to-slot text-primary" />
        </div>
        <div class="font-weight-bold">
          Wysłano!
        </div>
        <div style="font-size: 20px">
          Sprawdź skrzynkę email i zaakceptuj zaproszenie aby kontynuować
        </div>
        <div class="small mt-3">
          Numer zgłoszenia: <span class="text-secondary">
            {{ response.entryId }}
          </span>
        </div>

        <hr style="margin-top: 50px">
        <button
          class="btn btn-sm btn-secondary"
          type="submit"
          style="width: 180px; z-index: 1000; position: relative;"
          @click="repeat"
        >
          <i class="fa-solid fa-arrows-repeat pr-1" />
          Dodaj kolejne
        </button>
      </div>
    </div>
    <div
      v-else-if="error"
      class="response-info"
    >
      <div>
        <div class="text-center sent">
          <i class="fa-solid fa-triangle-exclamation" />
        </div>
        <div class="font-weight-bold">
          Formularz niedostępny
        </div>
        <div class="mt-1">
          wystąpił błąd podczas pobierania formularza<br>
          spróbuj ponownie później
        </div>
      </div>
    </div>
    <div
      v-else-if="inactive"
      class="response-info"
    >
      <div>
        <div class="text-center sent">
          <i class="fa-solid fa-ban text-secondary" />
        </div>
        <div class="font-weight-bold">
          Formularz nieaktywny
        </div>
        <div class="mt-1">
          spróbuj ponownie później lub skontaktuj się z {{ payeeName }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="form-body text-left"
    >
      <div class="mb-2 font-weight-bold payee-name">
        {{ payeeName }}
      </div>
      <hr class="mb-1">
      <div
        v-for="field in filteredLayout"
        :key="field.id"
        class="form-field"
      >
        <div
          v-if="field.type == 'statictext'"
        >
          <RichText
            :value="field.title"
            style="white-space: pre-wrap; width: 100%"
            :style="{
              'font-weight': field.bold ? '500' : undefined,
              'padding-bottom': field.separator ? '0.8rem' : undefined,
            }"
          />
          <hr
            v-if="field.separator"
            class="my-0"
          >
        </div>
        <div v-else>
          <label v-if="field.title && field.type !== 'checkbox'">
            <RichText :value="field.title" />
          </label>
          <div v-if="field.type === 'textinput'">
            <BFormInput
              v-model="values[field.code]"
              :state="validationErrors[field.code] ? false : undefined"
              :placeholder="field.title"
            />
          </div>
          <div v-else-if="field.type === 'textareainput'">
            <BFormTextarea
              v-model="values[field.code]"
              :state="validationErrors[field.code] ? false : undefined"
              :placeholder="field.title"
            />
          </div>
          <div v-else-if="field.type === 'checkbox'">
            <BFormCheckbox
              v-model="values[field.code]"
              class="form-checkbox"
              :state="validationErrors[field.code] ? false : undefined"
              style="margin-left: -10px"
              :placeholder="field.title"
            >
              <RichText :value="field.title" />
            </BFormCheckbox>
          </div>
          <div v-else-if="field.type === 'dropdown'">
            <BFormSelect
              :key="field.options.length"
              v-model="values[field.code]"
              :placeholder="field.title"
              :state="validationErrors[field.code] ? false : undefined"
              :options="field.options || []"
            />
          </div>
          <div v-else-if="field.type === 'fileinput'">
            <!-- <div class="custom-file">
              <input
                :id="`file-${field.code}`"
                type="file"
                class="custom-file-input"
                :class="{ 'is-invalid': validationErrors[field.code] }"
                :disabled="fileUploading[field.code]"
                @change="onFileSelected(field.code, $event)"
              >
              <label
                :for="`file-${field.code}`"
                class="custom-file-label"
              >
                {{ fileNames[field.code] || field.title || 'Wybierz plik...' }}
              </label>
            </div>
            <div
              v-if="fileUploading[field.code]"
              class="small text-muted mt-1"
            >
              <i class="fas fa-spinner fa-spin mr-1" />
              Wysyłanie...
            </div>
            <div
              v-else-if="values[field.code]"
              class="small text-success mt-1"
            >
              <i class="fas fa-check mr-1" />
              {{ fileNames[field.code] }}
            </div> -->
          </div>
          <div
            v-if="validationErrors[field.code] && validationErrors[field.code] != '#error#'"
            class="small text-danger"
          >
            {{ validationErrors[field.code] }}
          </div>
        </div>
        <div
          v-if="(field.attachments || []).length"
          class="field-attachments mt-1"
        >
          <a
            v-for="attachment in field.attachments"
            :key="attachment.key || attachment"
            :href="attachmentUrl(attachment)"
            target="_blank"
            rel="noopener noreferrer"
            class="field-attachment-link d-inline-flex align-items-center mr-3"
          >
            <i class="fas fa-file-alt text-muted mr-1" />
            <span class="small text-truncate">{{ attachmentLabel(attachment) }}</span>
          </a>
        </div>
      </div>
      <hr class="px-4">
      <div
        v-if="submitError"
        class="font-weight-bold text-danger py-2"
      >
        Wystąpił błąd przy zapisywaniu formularza. Spróbuj ponownie później lub skontaktuj się z {{ payeeName }}
      </div>
      <div
        class="text-right px-4"
        style="padding-bottom: 20px; margin-bottom: 20px"
      >
        <button
          class="btn btn-primary"
          type="button"
          :disabled="sending"
          style="width: 200px"
          @click="send"
        >
          Wyślij
        </button>
      </div>
    </div>

    <img
      src="@/assets/bottom-gradient.svg"
      class="bottom-gradient"
    >
  </div>
</template>

<script>
import axios from 'axios';
import {
  BFormCheckbox, BFormInput, BFormSelect, BFormTextarea,
} from 'bootstrap-vue';
import RichText from './RichText';

const baseUrl = process.env.VUE_APP_BASE_URL;

export default {
  data: () => ({
    error: false,
    submitError: '',
    pending: false,
    sending: false,
    layout: [],
    formAttachments: [],
    values: {},
    payeeName: '',
    response: null,
    validationErrors: {},
    searchParams: null,
    inactive: false,
    fileUploading: {},
    fileNames: {},
  }),
  components: {
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormSelect,
    RichText,
  },
  computed: {
    filteredLayout() {
      return this.layout
        .filter((x) => !x.showOnlyWhenField
        || this.values[x.showOnlyWhenField]?.toString() === x.showOnlyWhenValue.toString());
    },
  },
  methods: {
    attachmentUrl(attachment) {
      const key = attachment?.key || attachment;
      if (!key) return '#';
      return this.formAttachments.find((a) => a.key === key)?.url || '#';
    },
    attachmentLabel(attachment) {
      if (typeof attachment === 'string') return this.fileLabelFromKey(attachment);
      return attachment.name || this.fileLabelFromKey(attachment.key);
    },
    fileLabelFromKey(key) {
      if (!key) return '';
      const parts = key.split('/');
      return parts[parts.length - 1] || key;
    },
    async send() {
      const payeeId = this.searchParams.get('payeeId');
      const formId = this.searchParams.get('formId');

      await this.$recaptchaLoaded();

      const token = await this.$recaptcha('submit');

      this.sending = true;
      axios.post(`${baseUrl}/forms/public/${payeeId}/${formId}`, {
        token,
        values: Object.entries(this.values).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null) {
            acc[key] = value.toString();
          }
          return acc;
        }, {}),
      })
        .then(({ data }) => {
          if (data.validationErrors.length > 0) {
            this.validationErrors = {};
            data.validationErrors.forEach((x) => {
              this.$set(this.validationErrors, x.fieldCode, x.message || '#error#');
            });
          } else if (data.submitError) {
            this.submitError = data.submitError;
          } else {
            this.searchParams.set('entryId', data.entryId);
            window.history.pushState(null, '', `${window.location.pathname}?${this.searchParams.toString()}`);
            this.response = data;
          }
        })
        .catch(({ response: { data } }) => {
          this.error = data;
        })
        .finally(() => {
          this.sending = false;
        });
    },
    // async onFileSelected(code, event) {
    //   const file = event.target.files && event.target.files[0];
    //   if (!file) return;

    //   const payeeId = this.searchParams.get('payeeId');
    //   const formId = this.searchParams.get('formId');

    //   await this.$recaptchaLoaded();

    //   const token = await this.$recaptcha('submit');

    //   this.$set(this.fileUploading, code, true);
    //   this.$set(this.fileNames, code, file.name);

    //   const formData = new FormData();
    //   formData.append('File', file);
    //   formData.append('Token', token);

    //   axios.post(`${baseUrl}/forms/public/${payeeId}/${formId}/files`, formData)
    //     .then(({ data }) => {
    //       this.$set(this.values, code, data.key);
    //     })
    //     .catch(() => {
    //       this.$set(this.fileNames, code, null);
    //       this.$set(this.values, code, null);
    //     })
    //     .finally(() => {
    //       this.$set(this.fileUploading, code, false);
    //     });
    // },
    repeat() {
      this.response = null;
      this.searchParams.delete('entryId');
      this.values = {};
      this.fileNames = {};
      this.fileUploading = {};
      window.history.pushState(null, '', `${window.location.pathname}?${this.searchParams.toString()}`);
    },
  },
  created() {
    this.searchParams = new URLSearchParams(window.location.search);
    const entryId = this.searchParams.get('entryId');
    const payeeId = this.searchParams.get('payeeId');
    const formId = this.searchParams.get('formId');

    if (entryId) {
      this.response = {
        entryId,
      };
    }

    this.pending = true;
    axios.get(`${baseUrl}/forms/public/${payeeId}/${formId}`)
      .then(({ data }) => {
        this.inactive = !data.isActive;
        this.layout = JSON.parse(data.layout || '[]');
        this.payeeName = data.payeeName;
        this.formAttachments = data.attachments || [];
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.pending = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.form-field {
  padding: 0.8rem 0;
  overflow-wrap: anywhere;
}

.bottom-gradient {
  position: absolute;
  bottom: 0;
  z-index: 0;
  width: 100%;
}

@media screen and (max-width: 700px) {
  .bottom-gradient {
    display: none;
  }
}

.form-body {
  max-width: 600px;
  margin: auto;
  padding: 25px 30px 0px;
  background-color: white;
  border-radius: 20px;
  position: relative;
  z-index: 10;
}

.form-background {
  background-color: #F9F9F9;
  min-height: 100vh;
  padding-top: 65px;
  padding-bottom: 20px;
  position: relative;
}

.response-info {
  height: calc(100vh - 85px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.sent {
  i {
    font-size: 55px;
    padding-bottom: 15px;
  }
}

.payee-name {
  font-size: 1.5rem;
}

.field-attachments {
  width: 100%;
}

.field-attachment-link {
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.form-checkbox::v-deep .custom-control-label {
  font-weight: normal;
  text-transform: none;
  padding-top: 2px;
}

.logo {
  max-height: 30px;
  top: 20px;
  left: 20px;
  position: absolute;
}
</style>
